import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import mainAxios from '../../../services/mainAxios';
import selectStyle from '../../../design/selectStyle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const InvoiceFee = ({ disabled,invoiceState,setInvoiceState }) => {
  const { t } = useTranslation("translations");
  const [feeTypes, setFeeTypes] = useState([]);
  const [isLoading,setIsLoading] = useState(false)

  useEffect(() => {
    if(disabled)return
    const fetchFeeTypes = async () => {
        setIsLoading(true)
    await mainAxios.post("/apiEndpoint/search", {
        object: "GetFeeTypes",
        params: "{}",
    }).then(res=>{
        setIsLoading(false)
        if (res?.data?.status === true) {
            setFeeTypes(res.data.content);  
        }
    })
    .catch(err=>{
        setIsLoading(false)
    })

    }

 fetchFeeTypes();
  }, [t]);


  const handleFeeChange = (key,value,index) => {
    setInvoiceState((invoiceState) => {
        return {
            ...invoiceState,
            invoiceFees: invoiceState?.invoiceFees.map((fee, i) => {
                if (index === i) {
                return {
                    ...fee,
                    [key]: value
                };
                }
                return fee;
            })
        }
    });
  }


  const addDefaultFee = () => {
    setInvoiceState((invoiceState) => {
        return {
            ...invoiceState,
            invoiceFees: [...(invoiceState.invoiceFees || []),{ invoiceFeeType: null, feeAmount: "" }]
        }
    });
  }



  const handleDeletePayment = (index) => {
    setInvoiceState((invoiceState) => {
        return {
            ...invoiceState,
            invoiceFees: invoiceState?.invoiceFees.filter((_, i) => i !== index)
        }
    });
    }

  return (
    <div className='w-100'>
       {!disabled && <div className='d-flex align-items-center mb-2 gap-3'>
            {invoiceState?.invoiceFees?.length==0 && <h5 className='mb-0'>{t("invoice.feeEmpty")} </h5>}
            <button className="btn btn-outline-primary btn-xs" 
            onClick={addDefaultFee}>
                {t("invoice.addFee")}{" "}+</button>
            </div>}
        {invoiceState?.invoiceFees?.map((fee,index)=>{
            return (
                <div class="row w-full align-items-center">
                <div className="col-12 col-md-6">
                    <label className="label-txt">
                        {t("customers.type")}
                        <span className="text-danger"> *</span>
                    </label>
                    <Select
                    isLoading={isLoading}
                    placeholder={fee?.invoiceFeeType?.name ?? ""}
                    className="w-100"
                    isDisabled={disabled} 
                    styles={selectStyle}
                    options={feeTypes}
                    value={ feeTypes.find(feeType=>feeType.id===fee?.invoiceFeeType?.id) }
                    getOptionValue={(option) => option.id}
                    getOptionLabel={(option) => option.name}
                    onChange={(opt)=>handleFeeChange("invoiceFeeType",{id:opt.id},index)}
                    isSearchable={true}
                    name="invoiceFeeType"
                    />
                </div>
                    <div className="col-12 col-md-6">
                        <div className='d-flex align-items-end gap-2'>
                        <div>
                            <label className="label-txt">
                              {t("invoice.value")}
                            </label>
                            <input
                                type="number"
                                disabled={disabled}
                                className={`form-control`}
                                value={fee.feeAmount}
                                onChange={(e)=>handleFeeChange("feeAmount",e.target.value,index)}
                            />
                        </div>
                    {!disabled &&  <button className="btn btn-outline-danger" 
                        style={{height:33,width:"auto"}} 
                        onClick={() => handleDeletePayment(index)}>
                        <FontAwesomeIcon icon={faTrash} />
                        </button>}
                    </div>
                </div>
            </div>
            )
        })
            }

    </div>

  );
};

export default InvoiceFee;